export default __webpack_public_path__ + "static/media/gallery-5.b2cff389.jpg";